import React from 'react';
import '../../styles/TextInput.css';

/**
 * Currency input component with currency symbol prefix, matching TextInput styling
 * 
 * @param {string} value - Current input value
 * @param {function} onChange - Called with event { target: { value, name } }
 * @param {string} name - Form field name
 * @param {string} placeholder - Placeholder text
 * @param {boolean} disabled - Whether the input is disabled
 * @param {string} className - Additional CSS classes
 * @param {string} id - Input id for label association
 * @param {boolean} required - Whether the field is required
 * @param {string} symbol - Currency symbol (defaults to user preference or $)
 */
function CurrencyInput({ 
  value = '', 
  onChange, 
  name,
  placeholder = '0.00',
  disabled = false,
  className = '',
  id,
  required = false,
  symbol
}) {
  // Get currency symbol from user preferences or use provided symbol or default to $
  const getCurrencySymbol = () => {
    if (symbol) return symbol;
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      return user.currency_symbol || '$';
    } catch {
      return '$';
    }
  };

  const currencySymbol = getCurrencySymbol();

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={`text-input currency-input-container ${disabled ? 'disabled' : ''} ${className}`}>
      <span className="currency-prefix">{currencySymbol}</span>
      <input
        type="number"
        step="0.01"
        min="0"
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className="text-input-field"
      />
    </div>
  );
}

export default CurrencyInput;
